import React, { useCallback, useEffect, useRef, useState } from 'react'
import requestApi from '../../utils/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import TableListing from '../../components/TableListing/TableListing'
import Pagination from '../../components/Pagination'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import { useForm } from 'react-hook-form'
import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconEdit } from '../../assets/images/icons/icon-edit-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconRejected } from '../../assets/images/icons/icon-rejected-status.svg'
import { ReactComponent as IconApproveRight } from '../../assets/images/icons/icon-right-aprrove.svg'
import { ReactComponent as IconDesapproveClose } from '../../assets/images/icons/icon-close-desaprrove.svg'
import ApproveDeclinePopup from '../../components/ApproveDeclinePopup/ApproveDeclinePopup'
import Swal from 'sweetalert2'
import TableSkeleton from '../../components/TableSkeleton/TableSkeleton'
import StatusDropDown from '../../components/StatusDropDown/StatusDropDown'
import NoRecordFound from '../../components/NoRecordFound/NoRecordFound'
import AddEditModal from '../../components/AddEditModal/AddEditModal'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import InputControl from '../../components/InputControl'
import { GetColorName } from 'hex-color-to-color-name';

const validationSchemaForColor = yup.object({
    colorName: yup.string().required('Please enter color name')
})

const ColorManagement = () => {
    const myRef = useRef(null)

    const options = ['Pending', 'Active', 'InActive', 'Decline']
    const [selectedOption, setSelectedOption] = useState('')

    const handleDropdownSelect = (option) => {
        setSelectedOption(option)
        if (selectedOption === 'All' || selectedOption) {
            setCurrentPage(1)
        }
    }

    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [sorting, setSorting] = useState([])
    const [filter, setFilter] = useState(null)
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [ShowMaterialStatusPopup, setShowMaterialStatusPopup] =
        useState(false)
    const [statusUpdate, setStatusUpdate] = useState(null)
    const [buttonText, setButtonText] = useState('')
    const [deleteId, setDelteId] = useState('')
    const queryClient = useQueryClient()
    const EditDataRef = useRef(null)

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm()

    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    useEffect(() => {
        setCurrentPage(1)
    }, [searchKeyword])

    const handleSearch = useCallback((e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setSearchKeyword(e.target.value)
        }, 1000)
        clearInterval()
    }, [])

    //#region  Delete color by ID
    function handleDelete(colorId) {
        mutationDelete.mutate(colorId)
        setIsDeleteModal(false)
    }

    async function deleteColorId(colorId) {
        return await requestApi.post(`color/delete`, {
            colorId
        })
    }

    const mutationDelete = useMutation(deleteColorId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('colorlist')
            setIsDeleteModal(false)
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            })
        },
        onError: () => {
            EditDataRef.current = null
        }
    })

    //#endregion

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    function ColorList({ queryKey }) {
        return requestApi
            .post(
                `color/list`,
                {
                    limit: queryKey[2],
                    page: queryKey[1],
                    search: queryKey[3],
                    sortKey: queryKey[4]?.sortKey,
                    sortBy: queryKey[4]?.sortBy,
                    status: queryKey[5]
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data, isLoading } = useQuery({
        queryKey: [
            'colorlist',
            currentPage,
            DataLimit,
            searchKeyword,
            filter,
            selectedOption
        ],
        queryFn: ColorList
    })

    useEffect(() => {
        if (currentPage && data?.data?.length == 0) {
            setCurrentPage(currentPage - 1)
        } else {
        }
    }, [currentPage, data?.data])

    //#region  Table-Columns
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.accessor((row) => row?.name, {
            id: 'name',
            header: () => 'Name',
            cell: (row) => {
                return (
                    <>
                        <div style={{display:"inline-flex", gap:"10px"}}>
                        {/* <span
                                style={{
                                    backgroundColor: `${row?.row?.original?.name}`,
                                    borderRadius: '30%',
                                    height: '20px',
                                    width: '20px',
                                    border:""
                                }}
                            ></span> */}
                            <span >
                                {row?.row?.original?.name
                                    ? 
                                    // row?.row?.original?.name.includes('#')
                                    //     ? GetColorName(row?.row?.original?.name)
                                    // :
                                     row?.row?.original?.name
                                    : '-'}
                            </span>
                        </div>
                    </>
                )
            }
        }),

        columnHelper.accessor((row) => row?.status, {
            id: 'status',
            header: () => 'Status',
            enableSorting: false,
            cell: (row) => {
                switch (row?.row?.original?.status) {
                    case 7:
                        return (
                            <span className="pending-data status-data">
                                Pending
                            </span>
                        )
                    case 5:
                        return (
                            // <span className="decline-data status-data">
                            //    Decline
                            // </span>
                            <span class="rejected-status status-data">
                                <IconRejected /> Rejected
                            </span>
                        )

                    default:
                        return (
                            <>
                                <label className="switch">
                                    <input
                                        title={
                                            row?.row?.original?.status == 1
                                            ? "Active"
                                            :' In-Active'
                                        }
                                        type="checkbox"
                                        checked={
                                            row?.row?.original?.status == 1
                                                ? true
                                                : false
                                        }
                                        onChange={(e) =>
                                            onStatusChange(
                                                row?.row?.original?._id
                                            )
                                        }
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </>
                        )
                }
            }
        }),

        columnHelper.display({
            id: 'actions',
            header: () => 'Actions',
            cell: (row) => {
                switch (row?.row?.original?.status) {
                    case 7:
                        return (
                            <>
                                <div
                                    className={`table-action ${
                                        row?.row?.original?._id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                    onMouseLeave={() => setopenAction(null)}
                                >
                                    <div
                                        className={`action-btn ${
                                            row?.row?.original?._id ===
                                            openAction
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            OpenAction(row?.row?.original?._id)
                                        }
                                    >
                                        <IconsDots />
                                    </div>
                                    <div className="action-panel two-action">
                                        <div
                                            className="action-btn-icon edit"
                                            onClick={() => {
                                                handleApproveDecline(
                                                    row?.row?.original?._id,
                                                    setButtonText('Approve')
                                                )
                                            }}
                                        >
                                            <IconApproveRight />
                                        </div>
                                        <div
                                            className="action-btn-icon delete"
                                            onClick={() => {
                                                handleApproveDecline(
                                                    row?.row?.original?._id,
                                                    setButtonText('Decline')
                                                )
                                            }}
                                        >
                                            <IconDesapproveClose />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    case 5:
                        return <>-</>
                    default:
                        return (
                            <>
                                <div
                                    ref={myRef}
                                    className={`table-action ${
                                        row?.row?.original?._id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                    onMouseLeave={() => setopenAction(null)}
                                >
                                    <div
                                        className={`action-btn ${
                                            row?.row?.original?._id ===
                                            openAction
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            OpenAction(row?.row?.original?._id)
                                        }
                                    >
                                        <IconsDots />
                                    </div>
                                    <div className="action-panel two-action">
                                        <div
                                            className="action-btn-icon edit"
                                            // onClick={() =>
                                            //     navigate(coloraddedit, {
                                            //         state: row?.row?.original
                                            //             ?._id
                                            //     })
                                            // }
                                            onClick={() =>
                                                handleAddEditModal(
                                                    row?.row?.original
                                                )
                                            }
                                        >
                                            <IconEdit />
                                        </div>
                                        {/* <div className='action-btn-icon view'><IconView/></div> */}
                                        <div
                                            className="action-btn-icon delete"
                                            onClick={() =>
                                                handleDeleteModal(
                                                    row?.row?.original?._id
                                                )
                                            }
                                        >
                                            <IconDelete />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                }
            }
        })
    ]
    //#endregion

    const table = useReactTable({
        data: data?.data || [],
        columns: columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    //#region  Approve material Process
    const handleApproveDecline = (id) => {
        setShowMaterialStatusPopup(true)
        setStatusUpdate(id)
    }

    function handlePermission(colorId) {
        mutationStatusUpdate.mutate(colorId)
        setShowMaterialStatusPopup(false)
    }

    async function updateStatusbyId(colorId) {
        if (buttonText == 'Approve') {
            return await requestApi.post(`/color/approve-decline`, {
                colorId,
                status: 1
            })
        } else {
            return await requestApi.post(`/color/approve-decline`, {
                colorId,
                status: 5
            })
        }
    }
    const mutationStatusUpdate = useMutation(updateStatusbyId, {
        onSuccess: ({ data }) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            })
            queryClient.invalidateQueries('colorlist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

    //#region  Active/InActive Status Update
    const onStatusChange = useCallback((colorId) => {
        mutationStatusActiveInactive.mutate(colorId)
    }, [])
    async function updateStatusbyColorId(colorId) {
        return await requestApi.post(`/color/active-inactive-status`, {
            colorId
        })
    }

    const mutationStatusActiveInactive = useMutation(updateStatusbyColorId, {
        onSuccess: ({ data }) => {
            // Swal.fire({
            //     position: 'center',
            //     icon: 'success',
            //     title: '',
            //     text: data?.meta?.message
            // })
            queryClient.invalidateQueries('colorlist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

    //#region Modal for AddEdit
    const [AddEditShow, setAddEditShow] = useState(false)
    const [colorId, setcolorId] = useState('')

    const handleAddEditModal = (data) => {
        setAddEditShow(true)
        const { name, _id } = data
        msetValue('colorName', name)
        setcolorId(_id)
    }
    const handleAddEditModalForNew = () => {
        setAddEditShow(true)
        setcolorId(null)
        msetValue('colorName', null)
    }

    const {
        register: mregister,
        handleSubmit: mhandleSubmit,
        formState: { errors: merrors },
        setValue: msetValue
    } = useForm({
        mode: 'onChange',
        resolver: yupResolver(validationSchemaForColor)
    })
    //#endregion

    return (
        <div className="color-management">
            <div className="admin-card">
                <div class="head">
                    <h2>Color Management</h2>
                    <div className="search-btn-group">
                        <form
                            action=""
                            {...register('colorSearch', {
                                onChange: (e) => {
                                    handleSearch(e)
                                }
                            })}
                            className="product-table-filter"
                        >
                            <input
                                type="search"
                                name="colorSearch"
                                placeholder="Search"
                            />
                        </form>
                        <StatusDropDown
                            options={options}
                            onSelect={handleDropdownSelect}
                            selectedOption={selectedOption}
                        />
                        <button
                            onClick={() => handleAddEditModalForNew()}
                            className="solid-red-btn"
                        >
                            Add New Color
                        </button>
                    </div>
                </div>
            </div>

            {isLoading ? (
                <TableSkeleton />
            ) : data?.data?.length > 0 ? (
                <>
                    <TableListing table={table} className="m-0" getfilter={(e) => {setFilter(e)}} />
                    <div className="pagination-wrap">
                        <div className="showing-pages">
                            <span>
                                Showing {(currentPage - 1) * DataLimit + 1} to{' '}
                                {Math.min(
                                    currentPage * DataLimit,
                                    data.meta.totalCount
                                )}{' '}
                                of {data.meta.totalCount} colors
                            </span>
                        </div>

                        {data?.meta?.totalCount > 10 && (
                            <>
                                {/* <div className="itemperpage-box">
                                            <span>Items per page:</span>
                                            <Dropdown onSelect={handleChange}>
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {DataLimit}
                                                </Dropdown.Toggle>
        
                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="10">
                                                        10
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="20">
                                                        20
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="30">
                                                        30
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div> */}

                                <Pagination
                                    total={Math.ceil(
                                        data.meta.totalCount / DataLimit
                                    )}
                                    current={currentPage}
                                    onChangePage={handleChangePage}
                                />
                            </>
                        )}
                    </div>
                </>
            ) : (
                <div className="no-record-found">
                    <NoRecordFound />
                </div>
            )}

            <DeleteModal
                message={
                    <>
                        Are you sure you want to <br /> Delete this Color ?
                    </>
                }
                setIsDeleteModal={setIsDeleteModal}
                isDeleteModal={isDeleteModal}
                handleDelete={() => handleDelete(deleteId)}
            />

            <ApproveDeclinePopup
                ShowMaterialStatusPopup={ShowMaterialStatusPopup}
                setShowMaterialStatusPopup={setShowMaterialStatusPopup}
                setStatusUpdate={statusUpdate}
                title={`Are you sure you want to ${buttonText} ?`}
                // handlestatus={handlestatus}
                text={buttonText}
                handlePermission={() => handlePermission(statusUpdate)}
            />

            {/* AddEdit Modal Start */}
            <AddEditModal
                AddEditShow={AddEditShow}
                setAddEditShow={setAddEditShow}
                handleClose={() => setAddEditShow(false)}
            >
                <Child
                    register={mregister}
                    handleSubmit={mhandleSubmit}
                    errors={merrors}
                    setValue={msetValue}
                    colorId={colorId}
                    setcolorId={setcolorId}
                    setAddEditShow={setAddEditShow}
                    queryClient={queryClient}
                />
            </AddEditModal>
            {/* AddEdit Modal End */}
        </div>
    )
}
export default ColorManagement

//#region  Modal child Component
const Child = ({
    register,
    handleSubmit,
    errors,
    setValue,
    colorId,
    setcolorId,
    setAddEditShow,
    queryClient
}) => {
    async function colorAddEdit(payload) {
        try {
            if (colorId) {
                return await requestApi
                    .post(`color/add-edit`, {
                        colorId: colorId,
                        ...payload
                    })
                    .then((res) => {
                        return res.data
                    })
            } else {
                return await requestApi
                    .post(`color/add-edit`, payload)
                    .then((res) => {
                        return res.data
                    })
            }
        } catch (error) {
            console.log(error, 'Error')
        }
    }

    const mutation = useMutation(colorAddEdit, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(() => {
                setAddEditShow(false)
                setcolorId(null)
                setValue('colorName', null)
                queryClient.invalidateQueries('colorlist')
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })

    function handleColorAddEditSubmit(data) {
        console.log(data)
        const { colorName } = data
        let color = colorName
        try {
            mutation.mutate({ color })
        } catch (error) {
            console.log(error, 'Error')
        }
    }

    return (
        <div
            className=" admin-card"
            id="categorymodal001"
            name="categorymodal"
            aria-label="modal_cateogry"
        >
            <div class="head">
                <h2> {colorId ? ' Edit' : ' Add'} Color</h2>
            </div>
            <div className="admin-form-body">
                <form onSubmit={handleSubmit(handleColorAddEditSubmit)}>
                    <div className="form-group">
                        <InputControl
                            autoFocus={true}
                            label="color Name"
                            name="colorName"
                            register={register}
                            error={errors?.colorName?.message}
                        />
                        <button type="submit" className="solid-red-btn">
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}
//#endregion
